// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Preloader_wrapper__CyQ_f","dot":"Preloader_dot__OCoB1","circle":"Preloader_circle__mkYFt"};